// Standalone Pages (About, Privacy Policy, Legal, etc. — templates/page.json,
// sections/main-page.liquid) come from Shopify's plain-text rich text editor
// with no bold/heading markup of its own, in two different shapes:
//   - one <p> per "ラベル：内容" line (e.g. the Legal page), or
//   - a numbered heading and its body sharing one <p>, separated by <br>
//     (e.g. "1.個人情報の定義<br>「個人情報」とは…", the Privacy Policy page)
// This bolds, per <p>: a "ラベル：" prefix (up to the colon) when the whole
// paragraph is one line, or just the first line — a "N.見出し" heading or a
// "ラベル：" line — when a <br> splits it from the body that follows, so the
// body text itself never gets caught up in the bold. The very first
// paragraph of a page that has neither shape (a plain heading line with no
// colon and no following <br>, e.g. the Legal page's own title line) is
// bolded as a whole, once.
document.addEventListener('DOMContentLoaded', function () {
  var rte = document.querySelector('.main-page-title + .rte');
  if (!rte) return;

  var isFirstParagraph = true;

  function applyBold(el) {
    el.style.fontWeight = '700';
    el.style.webkitTextStroke = '0.2px currentColor';
  }

  // Walks node (a text node or an element, possibly containing its own
  // nested elements like a pre-existing <strong> some lines have around
  // just the "：") and bolds every character up to `charsLeft`, splitting a
  // text node if the boundary falls inside it. Returns the number of
  // characters still left to bold once this node (and, for an element, all
  // its descendants) has been fully processed.
  function boldRun(node, charsLeft) {
    if (charsLeft <= 0) return 0;

    if (node.nodeType === Node.TEXT_NODE) {
      var len = node.textContent.length;
      if (len <= charsLeft) {
        var strong = document.createElement('strong');
        node.parentNode.insertBefore(strong, node);
        strong.appendChild(node);
        return charsLeft - len;
      }
      node.splitText(charsLeft);
      var strongPartial = document.createElement('strong');
      node.parentNode.insertBefore(strongPartial, node);
      strongPartial.appendChild(node);
      return 0;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      var children = Array.prototype.slice.call(node.childNodes);
      for (var i = 0; i < children.length && charsLeft > 0; i++) {
        charsLeft = boldRun(children[i], charsLeft);
      }
    }

    return charsLeft;
  }

  // Length (in characters) of the text before the first <br> found anywhere
  // inside p, in document order. Returns -1 if p has no <br> at all.
  function firstLineLength(p) {
    var length = 0;
    var found = false;

    function walk(node) {
      if (found) return;
      if (node.nodeType === Node.TEXT_NODE) {
        length += node.textContent.length;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName === 'BR') {
          found = true;
          return;
        }
        for (var i = 0; i < node.childNodes.length && !found; i++) {
          walk(node.childNodes[i]);
        }
      }
    }

    walk(p);
    return found ? length : -1;
  }

  rte.querySelectorAll('p').forEach(function (p) {
    var raw = p.textContent.replace(/ /g, ' ');
    if (!raw.trim()) return;

    var wasFirstParagraph = isFirstParagraph;
    isFirstParagraph = false;

    var lineLength = firstLineLength(p);

    if (lineLength > 0) {
      var firstLine = raw.slice(0, lineLength).trim();
      var colonInLine = firstLine.indexOf('：');
      var isNumberedHeading = /^\d+[.、．]/.test(firstLine);
      var isLabelLine = colonInLine > 0 && colonInLine <= 20;
      if (isNumberedHeading || isLabelLine) {
        boldRun(p, lineLength);
      }
      return;
    }

    var trimmed = raw.trim();
    var colon = trimmed.indexOf('：');
    if (colon > 0 && colon <= 20) {
      var leadingWhitespace = raw.length - raw.replace(/^\s+/, '').length;
      boldRun(p, leadingWhitespace + colon + 1);
      return;
    }

    // Fallback: a plain heading line with neither a colon nor a following
    // <br> (e.g. the Legal page's own "特定商取引法に基づく表記" title
    // line) — only trusted on the very first paragraph of the page, so a
    // later plain sentence (e.g. "当ショップで収集する個人情報は以下の通り
    // です。" on the Privacy Policy page) isn't mistaken for one.
    if (wasFirstParagraph) {
      applyBold(p);
    }
  });
});
